import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6c9e77be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Everyone is Different."),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Sixliv's "),
      /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "AI-Enhanced Personalised Care.")
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Designed by a Practitioner for Practitioners. AI-Streamline Scheduling - Work Smart, Not Hard.", -1))
const _hoisted_5 = { id: "ai_pic" }
const _hoisted_6 = ["poster"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1))
const _hoisted_9 = { class: "mobile_detail" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Everyone is Different."),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Sixliv's "),
      /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "AI-Enhanced Personalised Care.")
    ])
  ])
], -1))
const _hoisted_11 = { class: "center" }
const _hoisted_12 = {
  class: "mobile_ai_pic",
  alt: ""
}
const _hoisted_13 = ["poster"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lorem ipsum dolor sit amet consectetur. Et risus diam nulla euismod commodo.", -1))

import { store } from "@/utils/store";
import { onMounted, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AIContent',
  setup(__props) {

const data = reactive({
  poster: "",
  videoUrl: "",
});
const handleOpen = () => {
  store.handleOpenAiModal();
};
onMounted(() => {
  if (localStorage.getItem("VIDEO_1")) {
    data.videoUrl = JSON.parse(localStorage.getItem("VIDEO_1") || "").videoUrl;
    data.poster = JSON.parse(localStorage.getItem("VIDEO_1") || "").imgUrl;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", { class: "bottom" }, [
        _hoisted_4,
        _createElementVNode("div", {
          onClick: handleOpen,
          class: "try_it"
        }, "Try it!")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("video", {
          class: "video-js",
          style: {"width":"100%","height":"100%"},
          poster: data.poster,
          controls: "",
          preload: "auto"
        }, [
          _createElementVNode("source", {
            src: data.videoUrl,
            type: "video/mp4"
          }, null, 8, _hoisted_7),
          _hoisted_8
        ], 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("video", {
            class: "video-js",
            style: {"width":"100%","height":"100%"},
            controls: "",
            poster: data.poster,
            preload: "auto"
          }, [
            _createElementVNode("source", {
              src: data.videoUrl,
              type: "video/mp4"
            }, null, 8, _hoisted_14),
            _hoisted_15
          ], 8, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", { class: "bottom" }, [
        _hoisted_16,
        _createElementVNode("div", {
          onClick: handleOpen,
          class: "try_it"
        }, "Try it!")
      ])
    ])
  ], 64))
}
}

})